<template>
  <page-tabs :items="analyticsPageItems" />
</template>

<script setup>
import { computed } from 'vue';
import PageTabs from '@/components/PageTabs.vue';
import useFeatureFlags from '@/composables/useFeatureFlags';
import useProductAvailability from '@/composables/useProductAvailability';
import State from '@/state/State';

const { tescoPortalStubsEnabled, portalUpdatesJan2026Enabled } = useFeatureFlags();
const { isBuildEnabled, isCoachEnabled, isBudgetEnabled, isRewardsEnabled, isSdlEnabled } = useProductAvailability();

const analyticsPageItems = computed(() => {
  const showIcons = !portalUpdatesJan2026Enabled.value;
  return [
    {
      ...(showIcons && { icon: 'chart-simple' }),
      name: 'Summary',
      to: 'analytics-homepage',
      visible: true,
    },
    {
      ...(showIcons && { icon: 'mobile-screen-button' }),
      name: 'App',
      to: 'analytics-app',
      visible: !portalUpdatesJan2026Enabled.value,
    },
    {
      name: 'Savings',
      to: 'analytics-savings',
      visible: portalUpdatesJan2026Enabled.value && isBuildEnabled.value,
    },
    {
      name: 'Education',
      to: 'analytics-education',
      visible: portalUpdatesJan2026Enabled.value && isCoachEnabled.value,
    },
    {
      name: 'Budget',
      to: 'analytics-budget',
      visible: portalUpdatesJan2026Enabled.value && isBudgetEnabled.value,
    },
    {
      name: 'Rewards',
      to: 'analytics-rewards',
      visible: portalUpdatesJan2026Enabled.value && isRewardsEnabled.value,
    },
    {
      name: 'Pay',
      to: 'analytics-pay',
      visible: portalUpdatesJan2026Enabled.value,
    },
    {
      name: 'Loans',
      to: 'analytics-loans',
      visible: portalUpdatesJan2026Enabled.value && isSdlEnabled.value,
    },
    {
      ...(showIcons && { icon: 'life-ring' }),
      name: 'Support',
      to: 'analytics-support',
      visible: tescoPortalStubsEnabled.value,
    },
    {
      ...(showIcons && { icon: 'calendar-alt' }),
      name: 'Shifts',
      to: 'analytics-shifts',
      visible: false,
    },
    {
      ...(showIcons && { icon: 'calendar-days' }),
      name: 'Bank Pay',
      to: 'analytics-bank-pay',
      visible: State.state.company?.properties?.weekly_pay_settings?.enabled || false,
    },
    {
      ...(showIcons && { icon: 'down-left-and-up-right-to-center' }),
      name: 'Compare',
      to: 'analytics-compare',
      visible: State.state.claims?.a || (State.state.claims?.m && State.state.divisions?.length > 1) || false,
    },
    {
      name: 'Impact',
      to: 'analytics-benchmark',
      visible: portalUpdatesJan2026Enabled.value,
    },
  ];
});
</script>
